(function () {
  let testimonialsSlide = () => {
    var $slickElement = $('.testimonials__slider').not('.slick-initialized');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $('.testimonials__counts').text(i + '/' + slick.slideCount);
    });

    $slickElement.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    $('.testimonials__button--next').off('click').on('click', function () {
      $('.testimonials__slider').slick('slickNext');
    });

    $('.testimonials__button--prev').off('click').on('click', function () {
      $('.testimonials__slider').slick('slickPrev');
    });
  };

  document.addEventListener('shopify:section:load', function () {
    testimonialsSlide();
  });

  testimonialsSlide();
})();